import { Alert, Button, message, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { DownloadOutlined } from "@ant-design/icons";

const OneEduReceipt = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [receiptData, setReceipt] = useState(null);

  const code = searchParams.get("code");

  useEffect(() => {
    const loadPDF = async () => {
      try {
        const response = await axios.get(
          `https://api-miniappedu.conek.vn/api/PhieuThuHocSinh/GetPhieuThuHocSinhTheoId?id=${code}`,
          {
            headers: {},
          }
        );
        setReceipt(response.data?.data || []);
      } catch (err) {
        message.error("Thất bại!");
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (code) loadPDF();
  }, [code]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (error || !code) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <Alert
          message="Lỗi tải thông tin!"
          type="error"
          showIcon
        />
      </div>
    );
  }

  if (!receiptData || receiptData.length === 0) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <Alert
          message="Vui lòng kiểm tra lại mã phiếu hoặc thử lại sau."
          type="warning"
          showIcon
        />
      </div>
    );
  }


  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("vi-VN").format(amount) + " đồng";
  };

  const convertToText = (number) => {
    const units = [
      "",
      "một",
      "hai",
      "ba",
      "bốn",
      "năm",
      "sáu",
      "bảy",
      "tám",
      "chín",
    ];
    const levels = ["", "nghìn", "triệu", "tỷ"];

    if (number === 0) return "Không đồng";

    let result = "";
    let levelIndex = 0;

    while (number > 0) {
      const group = number % 1000;
      if (group > 0) {
        result = convertGroup(group) + " " + levels[levelIndex] + " " + result;
      }
      number = Math.floor(number / 1000);
      levelIndex++;
    }

    return (
      result.trim().charAt(0).toUpperCase() +
      result.trim().slice(1) +
      " đồng"
    ).replace(/\s+/g, " ");
  };

  const convertGroup = (number) => {
    const units = [
      "",
      "một",
      "hai",
      "ba",
      "bốn",
      "năm",
      "sáu",
      "bảy",
      "tám",
      "chín",
    ];
    const hundred = Math.floor(number / 100);
    const ten = Math.floor((number % 100) / 10);
    const unit = number % 10;

    let result = "";

    if (hundred > 0) {
      result += units[hundred] + " trăm ";
    }

    if (ten > 1) {
      result += units[ten] + " mươi ";
      if (unit > 0) result += units[unit];
    } else if (ten === 1) {
      result += "mười ";
      if (unit > 0) result += units[unit];
    } else if (unit > 0 && hundred > 0) {
      result += "lẻ " + units[unit];
    } else if (unit > 0) {
      result += units[unit];
    }

    return result.trim();
  };

  // const formatDate = (dateStr) => {
  //   const date = new Date(dateStr);
  //   return {
  //     day: date.getDate(),
  //     month: date.getMonth() + 1,
  //     year: date.getFullYear(),
  //   };
  // };
  // const date = formatDate(receiptData.date);

  const details = receiptData?.hocPhiHoaDonDtos || [];

  // const giamTruList = details.filter(item => item.loaiKhoanThu === 1);
  // const khoanThuList = details.filter(item => item.loaiKhoanThu !== 1);

  const grouped = details.reduce(
    (acc, item) => {
      if (item.loaiKhoanThu === 1) {
        acc.giamTru.items.push(item);
        acc.giamTru.total += Number(item.tongTien || 0);
      } else {
        acc.khoanThu.items.push(item);
        acc.khoanThu.total += Number(item.tongTien || 0);
      }
      return acc;
    },
    {
      khoanThu: { items: [], total: 0 },
      giamTru: { items: [], total: 0 },
    }
  );

  return (
    <div
      style={{
        backgroundColor: "#F8FAFC",
        minHeight: "100vh",
        padding: "10px",
      }}
    >
      <style>{`
        * {
          box-sizing: border-box;
        }

        @media print {
          body * { visibility: hidden; }
          .print-area, .print-area * { visibility: visible; }
          .print-area {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            padding: 20px;
          }
          .no-print { display: none !important; }
        }

        .receipt-wrapper {
          background: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .receipt-container {
          font-family: 'DejaVu Sans', Arial, sans-serif;
          padding: 16px;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.5;
          font-size: 13px;
        }

        .header-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 16px;
          padding-bottom: 12px;
          border-bottom: 2px solid #E2E8F0;
          font-size: 12px;
        }

        .header-left {
          text-align: left;
        }

        .header-right {
          text-align: right;
        }

        .header-label {
          font-weight: 600;
          margin-bottom: 4px;
          display: block;
          font-size: 11px;
        }

        .title-section {
          text-align: center;
          margin: 20px 0 16px 0;
        }

        .receipt-title {
          font-size: 22px;
          font-weight: 700;
          margin: 0 0 8px 0;
          letter-spacing: 0.5px;
        }

        .receipt-date {
          font-size: 12px;
          margin: 4px 0 2px 0;
          color: #333;
        }

        .receipt-number {
          font-size: 12px;
          color: #666;
        }

        .info-section {
          margin: 16px 0;
          background: #f9f9f9;
          padding: 12px;
          border-radius: 6px;
        }

        .info-item {
          margin: 10px 0;
          display: flex;
          // flex-direction: column;
          justify-content: space-between;
        }

        .info-label {
          font-weight: 600;
          font-size: 12px;
          margin-bottom: 3px;
          color: #333;
        }

        .info-value {
          font-size: 13px;
          color: #555;
          word-break: break-word;
          line-height: 1.4;
        }

        .amount-highlight {
          background: #fff3cd;
          border-left: 4px solid #ff6b6b;
          padding: 10px 12px;
          margin: 12px 0;
          border-radius: 4px;
        }

        .amount-value {
          font-weight: 700;
          color: #E5065C;
          font-size: 16px;
        }

        .amount-text {
          font-size: 12px;
          margin-top: 6px;
          color: #333;
        }

        .qr-section {
          text-align: center;
          margin: 16px 0;
          padding: 12px 0;
          border: 1px dashed #CBD5E1;
          border-radius: 6px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .qr-image {
          width: 100%;
          max-width: 180px;
          height: auto;
          border-radius: 4px;
        }

        .details-section {
          margin: 16px 0;
        }

        .details-title {
          font-weight: 600;
          font-size: 13px;
          margin-bottom: 10px;
          padding-bottom: 8px;
          border-bottom: 2px solid #E2E8F0;
        }

        .detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid #F1F5F9;
          font-size: 12px;
        }

        .detail-row:last-child {
          border-bottom: none;
        }

        .detail-name {
          flex: 1;
          color: #333;
        }

        .detail-amount {
          font-weight: 600;
          color: #333;
          margin-left: 8px;
          text-align: right;
          min-width: 120px;
        }

        .summary-section {
          background: #f9f9f9;
          padding: 12px;
          border-radius: 6px;
          margin: 12px 0;
        }

        .summary-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 6px 0;
          font-size: 12px;
        }

        .summary-label {
          color: #666;
          font-weight: 500;
        }

        .summary-value {
          font-weight: 600;
          color: #333;
        }

        // .summary-total {
        //   border-top: 2px solid #CBD5E1;
        //   padding-top: 8px;
        //   margin-top: 8px;
        // }

        // .summary-total .summary-label {
        //   font-weight: 700;
        //   color: #E5065C;
        // }

        // .summary-total .summary-value {
        //   font-weight: 700;
        //   color: #E5065C;
        //   font-size: 14px;
        // }

        .summary-total {
          border-top: 2px solid #E5065C;
          padding-top: 10px;
          margin-top: 4px;
        }

        .summary-total .summary-label {
          font-weight: 700;
          font-size: 14px;
          color: #E5065C;
        }

        .summary-total .summary-value {
          font-weight: 700;
          font-size: 18px;
          color: #E5065C;
        }

        .signature-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-top: 32px;
          padding-top: 16px;
          border-top: 2px solid #E2E8F0;
        }

        .signature-box {
          text-align: center;
        }

        .signature-title {
          font-weight: 600;
          font-size: 12px;
          margin-bottom: 24px;
          color: #333;
        }

        .signature-line {
          font-size: 11px;
          color: #999;
          font-style: italic;
          margin-top: 32px;
        }

        .no-print {
          background: #0070D7;
          color: white;
          border: none;
          padding: 12px 16px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 600;
          width: 100%;
          margin-bottom: 12px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: background 0.3s;
        }

        .no-print:hover {
          background: #0050b3;
        }

        @media (max-width: 480px) {
          .receipt-container {
            padding: 12px;
            font-size: 12px;
          }

          .header-section {
            gap: 12px;
            margin-bottom: 12px;
            padding-bottom: 10px;
          }

          .header-label {
            font-size: 10px;
            margin-bottom: 3px;
          }

          .receipt-title {
            font-size: 18px;
            margin-bottom: 6px;
          }

          .receipt-date, .receipt-number {
            font-size: 14px;
          }

          .info-section {
            padding: 10px;
            margin: 12px 0;
          }

          .info-item {
            margin: 8px 0;
          }

          .info-label {
            font-size: 11px;
            margin-bottom: 2px;
          }

          .info-value {
            font-size: 12px;
          }

          .amount-value {
            font-size: 15px;
          }

          .qr-image {
            max-width: 160px;
          }

          .detail-row {
            padding: 6px 0;
            font-size: 11px;
          }

          .detail-amount {
            min-width: 100px;
          }

          .summary-row {
            font-size: 11px;
            padding: 5px 0;
          }

          .signature-section {
            gap: 12px;
            margin-top: 24px;
            padding-top: 12px;
          }

          .signature-title {
            font-size: 11px;
            margin-bottom: 20px;
          }

          .signature-line {
            font-size: 10px;
            margin-top: 24px;
          }
        }
          .detail-group {
  margin-bottom: 2px;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 2px;
}

.detail-group:last-child {
  border-bottom: none;
}

.group-label {
  font-weight: 600;
  font-size: 12px;
  padding: 5px 0 4px;
  border-bottom: 1px solid #CBD5E1;
  margin-bottom: 2px;
  color: #333;
}

.subtotal-row {
  border-top: 1px solid #333 !important;
  border-bottom: none !important;
  background: #F8FAFC;
  padding: 6px 0 !important;
}
      `}</style>

      <div className="receipt-wrapper print-area">
        <div className="receipt-container">
          {/* Header */}
          <div className="header-section">
            <div className="header-left">
              <span className="header-label">{receiptData?.tenTruong}</span>
              <div>{receiptData?.organization}</div>
              <span className="header-label" style={{ marginTop: "8px" }}>
                {receiptData?.diaChiTruong}
              </span>
            </div>
            <div className="header-right">
              <div style={{ fontWeight: 700, marginBottom: "8px" }}>C45-BB</div>
              <div style={{ fontSize: "10px", lineHeight: 1.3, color: "#666" }}>
                Ban hành theo TT số: 107/2017/TT-BTC
              </div>
            </div>
          </div>

          {/* Title */}
          <div className="title-section">
            <div className="receipt-title">PHIẾU BÁO CÁC KHOẢN THU</div>
            <div className="receipt-date">Tháng {receiptData?.thang}</div>
          </div>

          {/* Info Section */}
          <div className="info-section">
            <div className="info-item">
              <span className="info-label">Họ và tên người nộp tiền:</span>
              <span className="info-value">
                {receiptData?.tenHocSinh}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Lớp:</span>
              <span className="info-value">{receiptData?.lop}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Nội dung thu:</span>
              <span className="info-value">{receiptData?.ghiChu}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Số ngày nghỉ tháng trước:</span>
              <span className="info-value">{receiptData?.soNghiThangTruoc}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Tiền thừa tháng trước:</span>
              <span className="info-value">{formatCurrency(receiptData?.soTienThangTruoc)}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Ghi chú:</span>
              <span className="info-value">{receiptData?.ghiChu2}</span>
            </div>
          </div>

          {/* Amount Highlight */}
          <div className="amount-highlight">
            <div
              style={{ fontSize: "11px", color: "#666", marginBottom: "4px" }}
            >
              Tổng tiền
            </div>
            <div className="amount-value">
              {formatCurrency(receiptData?.tongTien)}
            </div>
            <div className="amount-text">
              <strong>(Viết bằng chữ):</strong>{" "}
              {convertToText(receiptData?.tongTien)}
            </div>
          </div>

          {/* QR Code */}
          {receiptData?.imgUrl && (
            <div className="qr-section">
              <img
                src={receiptData.imgUrl}
                alt="QR thanh toán"
                className="qr-image"
              />
              <div>
                {/* <h3>HƯỚNG DẪN THANH TOÁN</h3> */}
                {/* <span>
                  Đăng nhập ứng dụng ngân hàng &gt; Chọn quét QR &gt; Kiểm tra &gt;
                  Xác nhận thanh toán
                </span>
                <br />
                <span>(Không điều chỉnh nội dung thanh toán)</span> */}
                <Alert
                  message={

                    <div style={{ marginTop: 8, fontStyle: 'italic', fontSize: 13 }}>
                      <h3>HƯỚNG DẪN THANH TOÁN</h3>
                      <span>Đăng nhập ứng dụng ngân hàng &gt; Chọn quét QR &gt; Kiểm tra &gt;
                        Xác nhận thanh toán</span>
                      <br />
                      <span>(Không điều chỉnh nội dung thanh toán)</span>
                    </div>
                  }
                  type="info"
                />
              </div>

              <div style={{ marginTop: 5 }}>
                <a
                  href={receiptData.imgUrl}
                  download="qr-thanh-toan.png"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button icon={<DownloadOutlined />} style={{ fontSize: '12px' }}>
                    Tải QR Code
                  </Button>
                </a>
              </div>
            </div>
          )}

          {/* Details */}
          {/* <div className="details-section">
            <div className="details-title">Chi tiết khoản thu</div>
            {grouped.khoanThu.items.length > 0 && (
              <>
                <div className="group-title">Khoản thu</div>

                {grouped.khoanThu.items.map((item, index) => (
                  <div key={`fee-${index}`} className="detail-row">
                    <span className="detail-name">
                      {index + 1}. {item.tenKhoanThu}
                    </span>
                    <span className="detail-amount">
                      {formatCurrency(item.tongTien)}
                    </span>
                  </div>
                ))}

                <div className="detail-row total-row">
                  <span className="detail-name fw-bold">Tổng khoản thu</span>
                  <span className="detail-amount fw-bold">
                    {formatCurrency(grouped.khoanThu.total)}
                  </span>
                </div>
              </>
            )}

            {grouped.giamTru.items.length > 0 && (
              <>
                <div className="group-title text-danger">Giảm trừ</div>

                {grouped.giamTru.items.map((item, index) => (
                  <div key={`discount-${index}`} className="detail-row">
                    <span className="detail-name">
                      {index + 1}. {item.tenKhoanThu}
                    </span>
                    <span className="detail-amount text-danger">
                      {formatCurrency(item.tongTien)}
                    </span>
                  </div>
                ))}

                <div className="detail-row total-row">
                  <span className="detail-name fw-bold text-danger">
                    Tổng giảm trừ
                  </span>
                  <span className="detail-amount fw-bold text-danger">
                    {formatCurrency(grouped.giamTru.total)}
                  </span>
                </div>
              </>
            )}

            {receiptData?.tienDuNo > 0 && (
              <div className="detail-row">
                <span className="detail-name">
                  {details.length + 1}. {receiptData.lyDoTruyThu || "Truy thu"}
                </span>
                <span className="detail-amount">
                  {formatCurrency(receiptData.tienDuNo)}
                </span>
              </div>
            )}

            {receiptData?.tienGiamTru > 0 && (
              <div className="detail-row">
                <span className="detail-name">
                  {details.length + (receiptData.tienDuNo > 0 ? 2 : 1)}.{" "}
                  {receiptData.lyDoGiamTru || "Giảm trừ"}
                </span>
                <span className="detail-amount">
                  -{formatCurrency(receiptData.tienGiamTru)}
                </span>
              </div>
            )}
          </div> */}

          {/* Details */}
          <div className="details-section">
            <div className="details-title">Chi tiết khoản thu</div>

            {/* ===== Khoản thu ===== */}
            {grouped.khoanThu.items.length > 0 && (
              <div className="detail-group">
                <div className="group-label">Khoản thu</div>
                {grouped.khoanThu.items.map((item, index) => (
                  <div key={`fee-${index}`} className="detail-row">
                    <span className="detail-name">{index + 1}. {item.tenKhoanThu}</span>
                    <span className="detail-amount">{formatCurrency(item.tongTien)}</span>
                  </div>
                ))}
                <div className="detail-row subtotal-row">
                  <span className="detail-name" style={{ fontWeight: 700, color: '#E5065C', textAlign: 'center' }}>Tổng khoản thu</span>
                  <span className="detail-amount" style={{ fontWeight: 700, color: '#E5065C' }}>{formatCurrency(grouped.khoanThu.total)}</span>
                </div>
              </div>
            )}

            {/* ===== Giảm trừ ===== */}
            {grouped.giamTru.items.length > 0 && (
              <div className="detail-group">
                <div className="group-label">Giảm trừ</div>
                {grouped.giamTru.items.map((item, index) => (
                  <div key={`discount-${index}`} className="detail-row">
                    <span className="detail-name">{index + 1}. {item.tenKhoanThu}</span>
                    <span className="detail-amount">{formatCurrency(item.tongTien)}</span>
                  </div>
                ))}
                <div className="detail-row subtotal-row">
                  <span className="detail-name" style={{ fontWeight: 700, color: '#E5065C', textAlign: 'center' }}>Tổng giảm trừ</span>
                  <span className="detail-amount" style={{ fontWeight: 700, color: '#E5065C' }}>{formatCurrency(grouped.giamTru.total)}</span>
                </div>
              </div>
            )}

            {/* ===== Truy thu & Giảm trừ thêm ===== */}
            {(receiptData?.tienDuNo > 0 || receiptData?.tienGiamTru > 0) && (
              <div className="detail-group">
                {receiptData?.tienDuNo > 0 && (
                  <div className="detail-row">
                    <span className="detail-name">{details.length + 1}. {receiptData.lyDoTruyThu || "Truy thu"}</span>
                    <span className="detail-amount">{formatCurrency(receiptData.tienDuNo)}</span>
                  </div>
                )}
                {receiptData?.tienGiamTru > 0 && (
                  <div className="detail-row">
                    <span className="detail-name">
                      {details.length + (receiptData.tienDuNo > 0 ? 2 : 1)}. {receiptData.lyDoGiamTru || "Giảm trừ"}
                    </span>
                    <span className="detail-amount" style={{ color: '#E5065C' }}>-{formatCurrency(receiptData.tienGiamTru)}</span>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Summary */}
          <div className="summary-section">
            <div className="summary-row summary-total">
              <span className="summary-label">Số tiền phải thu:</span>
              <span className="summary-value">
                {formatCurrency(receiptData.tongTien)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneEduReceipt;